import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { Flex } from 'antd'
import { Station } from '@/type/stationType'
import useGlobalConfigStore from '@/stores/globalConfig'
import appConfig from '@/config'
import { GoogleMap, InfoWindowF, MarkerF } from '@react-google-maps/api'

type NodeInfoProps = {
  name: string
  image: string
  status: string
  datas: { label: string; value: string | number }[]
}
const NodeInfo: React.FC<NodeInfoProps> = ({ name, image, status, datas }) => {
  const { t } = useTranslation()
  return (
    <div className='NodeInfo'>
      <div className='NodeInfo-header'>
        <Flex gap={10}>
          <img src={image} style={{ width: 40, height: 40 }} />
          <Flex vertical gap={5}>
            <span className='NodeInfo-title'>{name}</span>
            <span className={`plantList-before plantList${status}`}>{t('status.' + status)}</span>
          </Flex>
        </Flex>
      </div>
      <Flex gap={10} vertical className='NodeInfo-content'>
        {datas?.map((item: any, index: number) => {
          return (
            <div className='NodeInfo-item' key={index}>
              <span className='NodeInfo-item-title'>{item.label}</span>
              {/* <NumberScroller targetNumber={item.value} /> */}
              {item.value}
            </div>
          )
        })}
      </Flex>
    </div>
  )
}

const Map: React.FC<{ station: Station[] }> = ({ station }) => {
  const { t } = useTranslation()
  const mapOk = useGlobalConfigStore(state => state.mapOk)
  const containerStyle = {
    width: '100%',
    height: window.innerHeight - 265,
  }
  const [markers, setMarkers] = useState<{ id: number; Node: JSX.Element; position: { lat: number; lng: number } }[]>(
    []
  )
  useEffect(() => {
    setMarkers(
      station.map(item => ({
        id: item.id,
        Node: (
          <NodeInfo
            name={item.station_name}
            image={appConfig.staticFile + item.station_image[0]}
            status={
              item.status === 'C001' || item.status === 'C002'
                ? 'online'
                : item.status === 'C003'
                ? 'warning'
                : item.status === 'C004'
                ? 'offline'
                : 'fault'
            }
            datas={[
              { label: t('site.totalDevices'), value: item.devices?.length || 0 },
              { label: t('site.installedCapacity'), value: item.installed_capacity },
              { label: t('site.bess'), value: item.rated_capacity },
              { label: t('site.createTime'), value: item.create_time },
            ]}
          />
        ),
        position: { lat: Number(item.latitude), lng: Number(item.longitude) },
      }))
    )
  }, [station, t])

  const [activeMarker, setActiveMarker] = useState<number | null>(null)
  const handleActiveMarker = (marker: number) => {
    // console.log('activemarker changed')
    if (marker === activeMarker) {
      return undefined
    }
    setActiveMarker(marker)
  }
  // const handleOnLoad = (map: google.maps.Map) => {
  //   const bounds = new google.maps.LatLngBounds()
  //   markers.forEach(({ position }) => bounds.extend(position))
  //   map.fitBounds(bounds)
  // }
  // const { isLoaded } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: apiKey,
  //   language: 'en',
  //   region: 'US',
  // })
  return mapOk ? (
    <div className='Map'>
      {/* <use language="en" region="US" googleMapsApiKey={apiKey}> */}
      <GoogleMap
        center={{ lat: -26, lng: 151.23064 }}
        mapContainerStyle={containerStyle}
        zoom={5}
        options={{ streetViewControl: false }}>
        {markers.map(({ id, Node, position }) => (
          <MarkerF key={id} position={position} icon='/assets/web/dhs.svg' onClick={() => handleActiveMarker(id)}>
            {activeMarker === id ? <InfoWindowF onCloseClick={() => setActiveMarker(null)}>{Node}</InfoWindowF> : null}
          </MarkerF>
        ))}
      </GoogleMap>
      {/* </use> */}
    </div>
  ) : (
    <></>
  )
}

export default Map
